(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["samo-countdown-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('samo-product-countdown-block')) {
    customElements.define('samo-product-countdown-block', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.hidden = false;
        const raw = (this.dataset.deadline || '').trim();
        const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/);
        const deadline = Date.parse(raw);
        let valid = !!match && Number.isFinite(deadline);
        if (match) {
          const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
          const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
          valid = valid && year >= 1000 && month >= 1 && month <= 12 && day >= 1 && day <= days && Number(match[4]) <= 23 && Number(match[5]) <= 59 && Number(match[6]) <= 59;
        }
        const timer = this.querySelector('.samob__timer');
        const ended = this.querySelector('.samob__ended');
        const notice = this.querySelector('.samob__notice');
        timer.hidden = true;
        ended.hidden = true;
        if (notice) notice.hidden = valid;
        if (!valid) return;
        const nodes = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
          values.forEach((value, index) => { nodes[index].textContent = String(value).padStart(2, '0'); });
          timer.hidden = false;
          if (remaining === 0) {
            this.stop();
            if (this.dataset.expiry === 'message') { timer.hidden = true; ended.hidden = false; }
            if (this.dataset.expiry === 'hide') {
              if (this.dataset.editor) { timer.hidden = true; ended.hidden = false; }
              else this.hidden = true;
            }
            return false;
          }
          return true;
        };
        if (update()) this.interval = window.setInterval(update, 1000);
      }
      stop() { window.clearInterval(this.interval); }
      disconnectedCallback() { this.stop(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
